@if (show) {<mat-progress-bar [mode]="mode"></mat-progress-bar>}